export default "__VITE_ASSET__BasPMDpn__"